{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "আপগ্রেড",
    "navBilling": "বিলিং"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "আপনার ট্যাব। আপনার <em>জিকির</em>।<br />উন্নীত।",
    "subtitle": "আরও উদ্দেশ্যপূর্ণ দিনের জন্য প্রয়োজনীয় প্রতিটি বৈশিষ্ট্য — নামাজের সময় ও AI আয়াত ভাবনা থেকে আবহাওয়া ও অগ্রাধিকার কাজ পর্যন্ত — একটি শান্ত, সুন্দর নতুন ট্যাবে।",
    "comparison_aria": "প্ল্যান তুলনা",
    "free": {
      "tierLabel": "বর্তমান",
      "tierName": "ফ্রি",
      "freeLabel": "সর্বদা ফ্রি",
      "list_aria": "ফ্রি প্ল্যানের বৈশিষ্ট্য"
    },
    "pro": {
      "list_aria": "Pro প্ল্যানের বৈশিষ্ট্য",
      "tierLabel": "আপগ্রেড করুন",
      "tierName": "Pro",
      "pricePeriod": "/ মাস",
      "priceAlt": "অথবা $39.99 / বছর"
    },
    "freeFeatures": {
      "clockDate": "ঘড়ি ও তারিখ প্রদর্শন",
      "verseOfDay": "দিনের কুরআন আয়াত",
      "dailyBackground": "দৈনিক ব্যাকগ্রাউন্ড ছবি",
      "qiblaCompass": "কিবলা কম্পাস",
      "basicTasks": "মৌলিক কাজ"
    },
    "proFeatures": {
      "weatherForecast": "৫-দিনের আবহাওয়ার পূর্বাভাস",
      "verseFavorites": "প্রিয় আয়াত সংরক্ষণ ও ব্রাউজ করুন",
      "notesAi": "AI বিশ্লেষণসহ নোট",
      "priorityTasks": "অগ্রাধিকার কাজ ব্যবস্থাপনা",
      "verseReflection": "AI সহ আয়াত ভাবনা"
    },
    "plans": {
      "monthly": {
        "label": "মাসিক",
        "price": "$4.99",
        "period": "/ মাস",
        "note": "মাসিক বিল করা হয়"
      },
      "yearly": {
        "label": "বার্ষিক",
        "price": "$39.99",
        "period": "/ বছর",
        "note": "দুই মাস ফ্রি",
        "badge": "৩৩% সাশ্রয়"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "যেকোনো সময় বাতিল করুন। আপনার অ্যাক্সেস বিলিং সময়কালের শেষ পর্যন্ত চলবে, কোনো আংশিক চার্জ ছাড়াই।",
    "billingPeriod_aria": "বিলিং সময়কাল",
    "cta": "নিরাপদ চেকআউটে এগিয়ে যান",
    "ctaLoading": "চেকআউটে পুনঃনির্দেশ করা হচ্ছে…",
    "promoManual": "ছাড় পেতে পরের পৃষ্ঠায় কোড {{code}} লিখুন।",
    "signingUpAs": "{{account}} হিসেবে সাইন আপ করা হচ্ছে",
    "trustSignals_aria": "বিশ্বাসের সংকেত",
    "reassurance": {
      "secureCheckout": "Stripe-এর মাধ্যমে নিরাপদ চেকআউট",
      "cancelAnytime": "যেকোনো সময় বাতিল করুন, কোনো প্রশ্ন নেই",
      "accessUntilEnd": "সময়কালের শেষ পর্যন্ত অ্যাক্সেস"
    },
    "errors": {
      "restoreSession": "আপনার সেশন পুনরুদ্ধার করা যায়নি। অনুগ্রহ করে এক্সটেনশন থেকে আবার চেষ্টা করুন।",
      "checkoutFailed": "চেকআউট শুরু করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।"
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "উন্মোচিত বৈশিষ্ট্য",
    "unlockedFeatures": {
      "weatherForecast": "৫-দিনের আবহাওয়ার পূর্বাভাস",
      "verseFavorites": "প্রিয় আয়াত সংরক্ষণ ও ব্রাউজ করুন",
      "notesAi": "AI বিশ্লেষণসহ নোট",
      "priorityTasks": "অগ্রাধিকার কাজ ব্যবস্থাপনা",
      "verseReflection": "AI সহ আয়াত ভাবনা"
    },
    "success": {
      "title": "Pro-তে স্বাগতম",
      "desc": "আপনার সাবস্ক্রিপশন সক্রিয়। সমস্ত Pro বৈশিষ্ট্য খুঁজে পেতে এক্সটেনশনে ফিরে যান।",
      "viewBilling": "বিলিং বিবরণ দেখুন",
      "closeTab": "এই ট্যাব বন্ধ করুন"
    },
    "cancel": {
      "title": "চেকআউট বাতিল হয়েছে",
      "desc": "চিন্তা নেই — আপনার প্ল্যান পরিবর্তন হয়নি এবং আপনাকে চার্জ করা হয়নি। আপনি যখন প্রস্তুত তখন আপগ্রেড করতে পারেন।",
      "backToUpgrade": "আপগ্রেডে ফিরে যান",
      "returnToExtension": "এক্সটেনশনে ফিরে যান"
    }
  },
  "billing": {
    "title": "বিলিং",
    "subtitle": "আপনার সাবস্ক্রিপশন পরিচালনা করুন ও পেমেন্ট ইতিহাস দেখুন।",
    "subscription_aria": "সাবস্ক্রিপশন স্ট্যাটাস",
    "subscriptionTitle": "সাবস্ক্রিপশন",
    "loading_aria": "বিলিং তথ্য লোড হচ্ছে",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "সক্রিয়",
      "trialing": "ফ্রি ট্রায়াল",
      "past_due": "বকেয়া",
      "unpaid": "অপরিশোধিত",
      "canceled": "বাতিল",
      "incomplete": "অসম্পূর্ণ",
      "none": "কোনো সাবস্ক্রিপশন নেই"
    },
    "planValues": {
      "proYearly": "Pro · বার্ষিক",
      "proMonthly": "Pro · মাসিক"
    },
    "warnings": {
      "paymentFailedTitle": "পেমেন্ট ব্যর্থ হয়েছে",
      "paymentFailedDesc": "আপনার শেষ পেমেন্টটি সম্পন্ন হয়নি। Pro অ্যাক্সেস বজায় রাখতে Manage Billing-এর মাধ্যমে আপনার পেমেন্ট পদ্ধতি আপডেট করুন।",
      "trialEndingTitle": "ট্রায়াল শীঘ্রই শেষ হচ্ছে",
      "trialEndingToday": "আপনার ফ্রি ট্রায়াল আজ {{date}}-এ শেষ হচ্ছে। আপনার Pro বৈশিষ্ট্য বজায় রাখতে একটি পেমেন্ট পদ্ধতি যোগ করুন।",
      "trialEndingInDays_one": "আপনার ফ্রি ট্রায়াল {{count}} দিনে {{date}}-এ শেষ হচ্ছে। আপনার Pro বৈশিষ্ট্য বজায় রাখতে একটি পেমেন্ট পদ্ধতি যোগ করুন।",
      "trialEndingInDays_other": "আপনার ফ্রি ট্রায়াল {{count}} দিনে {{date}}-এ শেষ হচ্ছে। আপনার Pro বৈশিষ্ট্য বজায় রাখতে একটি পেমেন্ট পদ্ধতি যোগ করুন।"
    },
    "cancellationScheduled": "বাতিলকরণ নির্ধারিত হয়েছে। <strong>{{date}}</strong> পর্যন্ত আপনি সম্পূর্ণ Pro অ্যাক্সেস রাখবেন।",
    "sublabel": {
      "trialEndsToday": "ট্রায়াল আজ শেষ হচ্ছে",
      "trialDaysRemaining_one": "ট্রায়ালে {{count}} দিন বাকি",
      "trialDaysRemaining_other": "ট্রায়ালে {{count}} দিন বাকি",
      "renews": "নবায়ন হবে {{date}}",
      "accessUntil": "{{date}} পর্যন্ত অ্যাক্সেস"
    },
    "kv": {
      "status": "স্ট্যাটাস",
      "nextRenewal": "পরবর্তী নবায়ন",
      "trialEnds": "ট্রায়াল শেষ হয়",
      "trialDaysLeft_one": "{{count}} দিন বাকি",
      "trialDaysLeft_other": "{{count}} দিন বাকি",
      "endsToday": "আজ শেষ হয়",
      "plan": "প্ল্যান"
    },
    "upgradeNudge": {
      "title": "Pro বৈশিষ্ট্য উন্মোচন করুন",
      "desc": "আবহাওয়া, নামাজের সময়, AI আয়াত ভাবনা ও আরও অনেক কিছু — $4.99/মাস অথবা $39.99/বছর।",
      "cta": "আপগ্রেড"
    },
    "actions": {
      "manageBilling": "বিলিং ও পেমেন্ট পদ্ধতি পরিচালনা করুন",
      "cancelConfirmTitle": "আপনার সাবস্ক্রিপশন বাতিল করবেন?",
      "cancelConfirmDesc": "আপনার বর্তমান বিলিং সময়কালের শেষ পর্যন্ত আপনি সম্পূর্ণ Pro অ্যাক্সেস রাখবেন। কোনো আংশিক রিফান্ড দেওয়া হয় না।",
      "canceling": "বাতিল হচ্ছে…",
      "yesCancel": "হ্যাঁ, বাতিল করুন",
      "keepPro": "Pro রাখুন",
      "cancelSubscription": "সাবস্ক্রিপশন বাতিল করুন"
    },
    "noSubscription": "কোনো সাবস্ক্রিপশন পাওয়া যায়নি।",
    "paymentHistory_aria": "পেমেন্ট ইতিহাস",
    "paymentHistoryTitle": "পেমেন্ট ইতিহাস",
    "invoices_aria": "চালান",
    "invoiceView": "দেখুন",
    "invoiceView_aria": "{{date}}-এর চালান দেখুন",
    "noInvoices": "এখনও কোনো চালান নেই।",
    "dangerZone_aria": "বিপজ্জনক অঞ্চল",
    "dangerZoneTitle": "বিপজ্জনক অঞ্চল",
    "deleteAccountTitle": "অ্যাকাউন্ট মুছুন",
    "deleteAccountDesc": "আপনার অ্যাকাউন্ট ও সমস্ত সংশ্লিষ্ট ডেটা — কাজ, নোট, প্রিয় ও বিলিং ইতিহাস — স্থায়ীভাবে মুছে ফেলুন। এই ক্রিয়াটি পূর্বাবস্থায় ফেরানো যায় না।",
    "deleteAccountBtn": "অ্যাকাউন্ট মুছুন",
    "deleteConfirm": {
      "warning": "এটি তাৎক্ষণিকভাবে ও স্থায়ীভাবে:",
      "list": {
        "deleteContent": "আপনার সমস্ত কাজ, নোট ও প্রিয় আয়াত মুছে ফেলবে",
        "cancelSubscription": "যেকোনো সক্রিয় সাবস্ক্রিপশন বাতিল করবে (অব্যবহৃত সময়ের জন্য কোনো রিফান্ড নেই)",
        "removeAccount": "আমাদের ডেটাবেস থেকে আপনার অ্যাকাউন্ট সরাবে",
        "signOut": "আপনাকে সমস্ত ডিভাইস থেকে সাইন আউট করবে"
      },
      "typeToConfirm": "নিশ্চিত করতে <strong>DELETE</strong> টাইপ করুন",
      "inputPlaceholder": "DELETE",
      "deleting": "মুছে ফেলা হচ্ছে…",
      "confirmBtn": "আমার অ্যাকাউন্ট স্থায়ীভাবে মুছুন",
      "cancelBtn": "বাতিল"
    },
    "errors": {
      "loadFailed": "বিলিং তথ্য লোড করা যায়নি।",
      "cancelFailed": "সাবস্ক্রিপশন বাতিল করা যায়নি।",
      "deleteFailed": "অ্যাকাউন্ট মুছা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন বা সহায়তার সাথে যোগাযোগ করুন।",
      "portalFailed": "বিলিং পোর্টাল খোলা যায়নি।"
    }
  },
  "privacy": {
    "tocLabel": "গোপনীয়তা নীতি",
    "toc_aria": "সূচিপত্র",
    "lastUpdated": "সর্বশেষ আপডেট<br />২২ সেপ্টেম্বর, ২০২৬",
    "sections": {
      "overview": "সংক্ষিপ্ত বিবরণ",
      "informationWeCollect": "আমরা যে তথ্য সংগ্রহ করি",
      "connectedServices": "সংযুক্ত পরিষেবা (Google, Todoist, Apple)",
      "howWeUse": "আমরা কীভাবে আপনার তথ্য ব্যবহার করি",
      "howWeShare": "আমরা কীভাবে আপনার তথ্য শেয়ার করি",
      "dataRetention": "ডেটা সংরক্ষণ",
      "yourRights": "আপনার গোপনীয়তার অধিকার",
      "california": "ক্যালিফোর্নিয়ার বাসিন্দা (CCPA/CPRA)",
      "cookies": "কুকিজ ও স্থানীয় সংরক্ষণ",
      "security": "ডেটা নিরাপত্তা",
      "changes": "এই নীতির পরিবর্তন",
      "contact": "আমাদের সাথে যোগাযোগ করুন"
    },
    "headings": {
      "informationWeCollect": "আমরা যে তথ্য সংগ্রহ করি",
      "connectedServices": "সংযুক্ত পরিষেবা (Google, Todoist, Apple)",
      "howWeUse": "আমরা কীভাবে আপনার তথ্য ব্যবহার করি",
      "howWeShare": "আমরা কীভাবে আপনার তথ্য শেয়ার করি",
      "dataRetention": "ডেটা সংরক্ষণ",
      "yourRights": "আপনার গোপনীয়তার অধিকার",
      "california": "ক্যালিফোর্নিয়ার বাসিন্দা (CCPA / CPRA)",
      "cookies": "কুকিজ ও স্থানীয় সংরক্ষণ",
      "security": "ডেটা নিরাপত্তা",
      "changes": "এই নীতির পরিবর্তন",
      "contact": "আমাদের সাথে যোগাযোগ করুন"
    }
  },
  "deleteAccount": {
    "intro": "অ্যাকাউন্ট মুছলে স্থায়ীভাবে মুছে যাবে:",
    "list": {
      "account": "আপনার অ্যাকাউন্ট ও প্রোফাইল",
      "tasks": "সমস্ত কাজ",
      "notes": "সমস্ত নোট",
      "verses": "সংরক্ষিত আয়াত",
      "billing": "সাবস্ক্রিপশনের রেকর্ড"
    },
    "irreversible": "এটি আর ফেরানো যাবে না।",
    "appleNotice": "অ্যাকাউন্ট মুছলে App Store থেকে কেনা সাবস্ক্রিপশন বাতিল হয় না। অনুগ্রহ করে সেটিংস → Apple ID → Subscriptions-এ গিয়েও তা বাতিল করুন।",
    "manageSubscription": "সাবস্ক্রিপশন পরিচালনা করুন",
    "continueBtn": "মুছে ফেলা চালিয়ে যান",
    "keepBtn": "আমার অ্যাকাউন্ট রাখুন",
    "confirmTitle": "অ্যাকাউন্ট মুছবেন?",
    "confirmDesc": "আপনার অ্যাকাউন্ট ও এর সমস্ত ডেটা স্থায়ীভাবে মুছে ফেলা হবে। এটি আর ফেরানো যাবে না।",
    "confirmBtn": "আমার অ্যাকাউন্ট স্থায়ীভাবে মুছুন",
    "deleting": "মুছে ফেলা হচ্ছে…",
    "error": "আপনার অ্যাকাউন্ট মুছে ফেলা যায়নি। অনুগ্রহ করে সংযোগ পরীক্ষা করে আবার চেষ্টা করুন।"
  }
}
